import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-3c7c2390"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "min-vh-100 bg-light" };
const _hoisted_2 = { class: "container py-5" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "text-center mb-5" }, "Mis Pedidos", -1 /* HOISTED */));
const _hoisted_4 = { class: "row g-4" };
const _hoisted_5 = { class: "card h-100 shadow-sm" };
const _hoisted_6 = { class: "card-body d-flex flex-column" };
const _hoisted_7 = { class: "card-title" };
const _hoisted_8 = { class: "card-text mb-1" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Fecha:", -1 /* HOISTED */));
const _hoisted_10 = { class: "card-text mb-3" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Total:", -1 /* HOISTED */));
const _hoisted_12 = { key: 0 };
const _hoisted_13 = {
    key: 0,
    class: "pendiente-text ms-2"
};
const _hoisted_14 = { class: "mt-auto" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
    key: 0,
    class: "mt-4"
};
const _hoisted_17 = { class: "pagination justify-content-center align-items-center flex-nowrap" };
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
    key: 1,
    class: "d-flex justify-content-center py-5"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "spinner-border text-primary",
    role: "status"
}, null, -1 /* HOISTED */));
const _hoisted_21 = [
    _hoisted_20
];
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-center py-5 text-muted" }, " No tienes pedidos aún. ", -1 /* HOISTED */));
const _hoisted_23 = { class: "modal-dialog modal-lg modal-dialog-scrollable" };
const _hoisted_24 = { class: "modal-content rounded-4 shadow-lg" };
const _hoisted_25 = { class: "modal-header border-0 pb-0" };
const _hoisted_26 = { class: "modal-title fw-bold text-primary" };
const _hoisted_27 = { class: "modal-body p-4" };
const _hoisted_28 = { class: "card border-0 rounded-3 mb-3 bg-light-subtle" };
const _hoisted_29 = { class: "card-body" };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h6", { class: "card-title fw-semibold text-dark" }, "Información General", -1 /* HOISTED */));
const _hoisted_31 = { class: "mb-1 text-muted" };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-calendar me-2" }, null, -1 /* HOISTED */));
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "Fecha:", -1 /* HOISTED */));
const _hoisted_34 = { class: "d-flex align-items-center mt-2" };
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "fw-bold text-dark me-2" }, "Estado:", -1 /* HOISTED */));
const _hoisted_36 = {
    key: 0,
    class: "ms-2 text-muted"
};
const _hoisted_37 = { class: "card border-0 rounded-3" };
const _hoisted_38 = { class: "card-body p-0" };
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h6", { class: "px-4 pt-3 pb-2 fw-semibold text-dark" }, "Productos en el pedido", -1 /* HOISTED */));
const _hoisted_40 = { class: "table-responsive" };
const _hoisted_41 = { class: "table table-striped table-hover m-0" };
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "text-nowrap text-secondary"
        }, "Producto"),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "text-nowrap text-secondary"
        }, "Repuesto"),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "text-nowrap text-secondary"
        }, "Vendedor"),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "text-center text-nowrap text-secondary"
        }, "Cant. Solicitada"),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "text-center text-nowrap text-secondary"
        }, "Cant. Confirmada"),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "text-end text-nowrap text-secondary"
        }, "Precio Unitario"),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "text-end text-nowrap text-secondary"
        }, "Total Parcial"),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "text-center text-nowrap text-secondary"
        }, "Estado ")
    ])
], -1 /* HOISTED */));
const _hoisted_43 = { class: "d-flex align-items-center gap-2" };
const _hoisted_44 = ["src"];
const _hoisted_45 = { class: "align-middle" };
const _hoisted_46 = { class: "align-middle" };
const _hoisted_47 = { class: "text-center align-middle" };
const _hoisted_48 = { class: "text-center align-middle" };
const _hoisted_49 = { class: "text-end align-middle" };
const _hoisted_50 = { class: "text-end align-middle" };
const _hoisted_51 = { class: "text-center align-middle" };
const _hoisted_52 = { class: "d-flex justify-content-end align-items-center mt-4" };
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", { class: "fw-bold text-dark m-0 me-3" }, "Total a pagar:", -1 /* HOISTED */));
const _hoisted_54 = { class: "fw-bolder text-primary m-0" };
const _hoisted_55 = { class: "modal-footer border-0 pt-0 justify-content-between" };
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-credit-card-fill me-2" }, null, -1 /* HOISTED */));
const _hoisted_57 = {
    key: 1,
    class: "modal-backdrop fade show"
};
import { ref, computed, onMounted } from "vue";
import Header from "@/components/Header.vue";
import Swal from "sweetalert2";
import { PedidoService } from "@/services/PedidoService";
import { formatCurrency } from "@/utils/formatPrice";
import { config } from '@/config';
import { useRouter } from "vue-router"; // 👈 Importar el router
// ... resto de imports
const itemsPorPagina = 6;
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const router = useRouter(); // 👈 Inicializar el router
        const pedidos = ref([]);
        const pedidoSeleccionado = ref(null);
        const modalVisible = ref(false);
        const isLoading = ref(false);
        // Paginación
        const paginaActual = ref(1);
        const pedidosPaginados = computed(() => {
            const inicio = (paginaActual.value - 1) * itemsPorPagina;
            const fin = inicio + itemsPorPagina;
            return pedidos.value.slice(inicio, fin);
        });
        const paginas = computed(() => Math.ceil(pedidos.value.length / itemsPorPagina));
        const cambiarPagina = (pagina) => {
            if (pagina < 1 || pagina > paginas.value)
                return;
            paginaActual.value = pagina;
        };
        const formatFecha = (fecha) => {
            return fecha ? new Date(fecha).toLocaleDateString("es-ES", { year: "numeric", month: "long", day: "numeric" }) : "";
        };
        const getEstadoClase = (estado) => {
            switch (estado) {
                case "Pendiente":
                    return "estado-pendiente";
                case "Pago Pendiente de Verificación":
                    return "estado-pago-verificacion";
                case "Preparando":
                    return "estado-preparando";
                case "Confirmado":
                    return "estado-confirmado";
                case "Pagado":
                    return "estado-pagado";
                case "En envío":
                    return "estado-envio";
                case "Completado":
                    return "estado-completado";
                case "Rechazado":
                    return "estado-rechazado";
                default:
                    return "estado-desconocido";
            }
        };
        // Revisa si todos los productos están confirmados
        const todosConfirmados = (pedido) => {
            if (!pedido || !pedido.detalles)
                return false;
            return pedido.detalles.every(p => p.confirmado);
        };
        const productosConfirmados = (pedido) => {
            if (!pedido.detalles)
                return 0;
            return pedido.detalles.filter(p => p.confirmado).length;
        };
        const totalProductos = (pedido) => {
            if (!pedido.detalles)
                return 0;
            return pedido.detalles.length;
        };
        // Calcula el total a pagar considerando solo productos confirmados
        const totalAPagar = computed(() => {
            if (!pedidoSeleccionado.value)
                return 0;
            return pedidoSeleccionado.value.detalles
                .filter(p => p.confirmado)
                .reduce((sum, p) => sum + p.precioVenta * p.cantidadConfirmada, 0);
        });
        const abrirModalDetalles = (pedido) => {
            pedidoSeleccionado.value = pedido;
            modalVisible.value = true;
        };
        const getImagen = (imagen) => {
            if (!imagen)
                return require("@/assets/paquete.png");
            return imagen.startsWith('http') ? imagen : `${config.API_URL}/${imagen}`;
        };
        const cerrarModal = () => {
            modalVisible.value = false;
            pedidoSeleccionado.value = null;
        };
        // Reemplaza tu función actual con esta:
        const pagarPedido = (pedido) => {
            if (!pedido)
                return;
            // 1. Validar que todos los productos estén confirmados.
            if (!todosConfirmados(pedido)) {
                Swal.fire("Atención", "No puedes pagar un pedido con productos pendientes de confirmación", "warning");
                return;
            }
            console.log("Id en pedido:", pedido.pedidoId);
            // 2. Redireccionar a la vista de pago
            router.push({
                name: 'Pagos',
                params: { pedidoId: pedido.pedidoId.toString() }
            });
            // 3. Cerrar el modal después de la redirección
            cerrarModal();
        };
        onMounted(async () => {
            isLoading.value = true;
            try {
                const response = await PedidoService.confirmacionesComprador();
                if (response.exito)
                    pedidos.value = response.datos;
                else
                    Swal.fire("Error", response.errores || "No se pudieron cargar tus pedidos", "error");
            }
            catch {
                Swal.fire("Error", "No se pudieron cargar tus pedidos", "error");
            }
            finally {
                isLoading.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createCommentVNode(" Lista de pedidos "),
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pedidosPaginados.value, (pedido) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: pedido.pedidoId,
                                class: "col-12 col-md-6 col-lg-4"
                            }, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("h5", _hoisted_7, "Pedido #" + _toDisplayString(pedido.codigoPedido), 1 /* TEXT */),
                                        _createElementVNode("p", _hoisted_8, [
                                            _hoisted_9,
                                            _createTextVNode(" " + _toDisplayString(formatFecha(pedido.fechaCreacion)), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("p", _hoisted_10, [
                                            _hoisted_11,
                                            _createTextVNode(" " + _toDisplayString(_unref(formatCurrency)(pedido.total)), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(['badge mb-3', getEstadoClase(pedido.estado)])
                                        }, [
                                            _createTextVNode(_toDisplayString(pedido.estado) + " ", 1 /* TEXT */),
                                            _createCommentVNode(" Mostrar recuento solo si está confirmado "),
                                            (pedido.estado === 'Confirmado')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (" + _toDisplayString(productosConfirmados(pedido)) + "/" + _toDisplayString(totalProductos(pedido)) + ") ", 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ], 2 /* CLASS */),
                                        _createCommentVNode(" Pendiente de pagar "),
                                        (pedido.estado === 'Confirmado' && todosConfirmados(pedido))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Pendiente de pagar "))
                                            : _createCommentVNode("v-if", true),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("button", {
                                                class: "btn btn-primary w-100",
                                                onClick: ($event) => (abrirModalDetalles(pedido))
                                            }, " Ver Detalles ", 8 /* PROPS */, _hoisted_15)
                                        ])
                                    ])
                                ])
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _createCommentVNode(" Paginación "),
                    (paginas.value > 1)
                        ? (_openBlock(), _createElementBlock("nav", _hoisted_16, [
                            _createElementVNode("ul", _hoisted_17, [
                                _createCommentVNode(" Botón anterior "),
                                _createElementVNode("li", {
                                    class: _normalizeClass(["page-item", { disabled: paginaActual.value === 1 }])
                                }, [
                                    _createElementVNode("button", {
                                        class: "page-link",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (cambiarPagina(paginaActual.value - 1)))
                                    }, "« Anterior")
                                ], 2 /* CLASS */),
                                _createCommentVNode(" Números de página "),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginas.value, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: page,
                                        class: _normalizeClass(["page-item", { active: page === paginaActual.value }])
                                    }, [
                                        _createElementVNode("button", {
                                            class: "page-link",
                                            onClick: ($event) => (cambiarPagina(page))
                                        }, _toDisplayString(page), 9 /* TEXT, PROPS */, _hoisted_18)
                                    ], 2 /* CLASS */));
                                }), 128 /* KEYED_FRAGMENT */)),
                                _createCommentVNode(" Botón siguiente "),
                                _createElementVNode("li", {
                                    class: _normalizeClass(["page-item", { disabled: paginaActual.value === paginas.value }])
                                }, [
                                    _createElementVNode("button", {
                                        class: "page-link",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (cambiarPagina(paginaActual.value + 1)))
                                    }, "Siguiente »")
                                ], 2 /* CLASS */)
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Loading "),
                    (isLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                        : (!isLoading.value && pedidos.value.length === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createCommentVNode(" No pedidos "),
                                _hoisted_22
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" Modal Detalles Pedido "),
                (modalVisible.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["modal fade", { show: modalVisible.value }]),
                        tabindex: "-1",
                        style: { "display": "block" }
                    }, [
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("h5", _hoisted_26, "Detalles del Pedido #" + _toDisplayString(pedidoSeleccionado.value?.codigoPedido), 1 /* TEXT */),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        onClick: cerrarModal,
                                        "aria-label": "Cerrar"
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("div", _hoisted_29, [
                                            _hoisted_30,
                                            _createElementVNode("p", _hoisted_31, [
                                                _hoisted_32,
                                                _hoisted_33,
                                                _createTextVNode(" " + _toDisplayString(formatFecha(pedidoSeleccionado.value?.fechaCreacion)), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_34, [
                                                _hoisted_35,
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(['badge', getEstadoClase(pedidoSeleccionado.value?.estado), 'fs-6'])
                                                }, _toDisplayString(pedidoSeleccionado.value?.estado), 3 /* TEXT, CLASS */),
                                                (pedidoSeleccionado.value?.estado !== 'Pagado')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, " (" + _toDisplayString(productosConfirmados(pedidoSeleccionado.value)) + "/" + _toDisplayString(totalProductos(pedidoSeleccionado.value)) + ") confirmados ", 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                            _hoisted_39,
                                            _createElementVNode("div", _hoisted_40, [
                                                _createElementVNode("table", _hoisted_41, [
                                                    _hoisted_42,
                                                    _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pedidoSeleccionado.value?.detalles || [], (producto, index) => {
                                                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                                _createElementVNode("td", _hoisted_43, [
                                                                    (producto.imagenUrl)
                                                                        ? (_openBlock(), _createElementBlock("img", {
                                                                            key: 0,
                                                                            src: getImagen(producto.imagenUrl),
                                                                            alt: "Producto",
                                                                            class: "producto-img-modal rounded-2"
                                                                        }, null, 8 /* PROPS */, _hoisted_44))
                                                                        : _createCommentVNode("v-if", true)
                                                                ]),
                                                                _createElementVNode("td", _hoisted_45, _toDisplayString(producto.nombreRepuesto), 1 /* TEXT */),
                                                                _createElementVNode("td", _hoisted_46, _toDisplayString(producto.nombreVendedor), 1 /* TEXT */),
                                                                _createElementVNode("td", _hoisted_47, _toDisplayString(producto.cantidadSolicitada), 1 /* TEXT */),
                                                                _createElementVNode("td", _hoisted_48, _toDisplayString(producto.confirmado ?
                                                                    producto.cantidadConfirmada : '-'), 1 /* TEXT */),
                                                                _createElementVNode("td", _hoisted_49, _toDisplayString(_unref(formatCurrency)(producto.precioVenta)), 1 /* TEXT */),
                                                                _createElementVNode("td", _hoisted_50, _toDisplayString(producto.confirmado ?
                                                                    _unref(formatCurrency)(producto.precioVenta * producto.cantidadConfirmada) :
                                                                    '-'), 1 /* TEXT */),
                                                                _createElementVNode("td", _hoisted_51, [
                                                                    _createElementVNode("span", {
                                                                        class: _normalizeClass(['badge', producto.confirmado ? 'bg-success' : 'bg-warning text-dark'])
                                                                    }, [
                                                                        _createElementVNode("i", {
                                                                            class: _normalizeClass([producto.confirmado ? 'bi bi-check-circle-fill' : 'bi bi-clock-fill', "me-1"])
                                                                        }, null, 2 /* CLASS */),
                                                                        _createTextVNode(" " + _toDisplayString(producto.confirmado ? 'Confirmado' : 'Pendiente'), 1 /* TEXT */)
                                                                    ], 2 /* CLASS */)
                                                                ])
                                                            ]));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_52, [
                                        _hoisted_53,
                                        _createElementVNode("h4", _hoisted_54, _toDisplayString(_unref(formatCurrency)(totalAPagar.value)), 1 /* TEXT */)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("button", {
                                        class: "btn btn-secondary rounded-pill",
                                        onClick: cerrarModal
                                    }, "Cerrar"),
                                    (pedidoSeleccionado.value?.estado === 'Confirmado'
                                        && todosConfirmados(pedidoSeleccionado.value))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn btn-success rounded-pill",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (pagarPedido(pedidoSeleccionado.value)))
                                        }, [
                                            _hoisted_56,
                                            _createTextVNode("Pagar Pedido ")
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ])
                    ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Modal backdrop "),
                (modalVisible.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
